import { render, staticRenderFns } from "./box-create.vue?vue&type=template&id=56e85f62&scoped=true"
import script from "./box-create.vue?vue&type=script&lang=js"
export * from "./box-create.vue?vue&type=script&lang=js"
import style0 from "./box-create.vue?vue&type=style&index=0&id=56e85f62&prod&lang=css"
import style1 from "./box-create.vue?vue&type=style&index=1&id=56e85f62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e85f62",
  null
  
)

/* custom blocks */
import block0 from "./box-create.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports